import React, { Component, useState } from 'react'; 
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Modal from './CustomModal'
import ModalHeader from './ModalHeader'
import ModalBody from './ModalBody'
import authInstance from '../Classes/AuthHandler';



class SuccessFailureModal extends Component {

    constructor(props) {
        super(props);
        this.state={           
        }
        
        this.modal= this.modal.bind(this); 
        // this.modalLogistics=this.modalLogistics.bind(this);
        
    }

   
    modal() {
        this.props.toggleSuccessModal(false)     
    }  

 render(){
    
    var roles = authInstance.getRoles()
    var groups = authInstance.getGroups()
    return(
      <div>
      
        <div>
        <Modal  isOpen={this.props.action} >
                <div className={"modal-bg" + (this.props.action === 'false'  ? 'open' : '')}>
                <div className="modalheads">
                <ModalHeader HeaderStyle="modalheader">
                   <div className="pt-2 mt-1 text-center modal-text"><h4>{this.props.headertitle}
                   {!roles[13] ?
                   <button type="button" className="pr-2 close" aria-label="Close" onClick={this.modal}> <span aria-hidden="true">&times;</span>
                   </button>            
                   :             
                   <button type="button" className="pr-2 close" aria-label="Close" onClick={this.UploadSuccessModal}><span aria-hidden="true">&times;</span></button>
                   }
              
                   </h4>
                   </div>
                </ModalHeader>
                </div>
                <div >
                <ModalBody Style="modal-body modalbodys">
                      <div className="row text-center pb-2 modal-text">
                       <FontAwesomeIcon icon={this.props.icon} className="submission-check-cirle" color={this.props.iconcolor} size="10x" />
                       </div>
                       <div className="row-sm-2 ml-4 pl-2 pt-4 text-center modal-text">
                         {this.props.text}
                       </div>
                </ModalBody>
                </div>
                <div>
                    
                </div>
                </div>
            </Modal>         
        </div>
        
    </div>
       
     
 )
 
  }
}
 

export default SuccessFailureModal;